// extracted by mini-css-extract-plugin
export var opacity = "Aurora-orb02-module--opacity--ILuCJ";
export var orb = "Aurora-orb02-module--orb--ur0h7";
export var rotation = "Aurora-orb02-module--rotation--isOV-";
export var scaleX = "Aurora-orb02-module--scaleX---H73D";
export var scaleY = "Aurora-orb02-module--scaleY--LWL4Q";
export var xaxis = "Aurora-orb02-module--xaxis---zU6V";
export var yaxis = "Aurora-orb02-module--yaxis--dD5tO";